/* Fluido theme runtime: scroll reveal + safety fallback */
(function () {
  'use strict';

  function initReveal() {
    var els = document.querySelectorAll('.reveal, .reveal-on-scroll');
    if (!els.length) return;

    // If IntersectionObserver is unavailable, just show everything.
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.classList.add('in');
        el.classList.add('active');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          entry.target.classList.add('active');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });

    els.forEach(function (el) { observer.observe(el); });

    // Safety net: anything still hidden after 1.2s gets revealed.
    setTimeout(function () {
      document.documentElement.classList.add('fluido-loaded');
    }, 1200);
  }

  // Remove the .no-js guard as soon as JS runs.
  document.documentElement.classList.remove('no-js');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }

  // Re-init when sections are added/edited in the Theme Editor.
  document.addEventListener('shopify:section:load', initReveal);
})();
